/**
 * @generated SignedSource<<2cf3963ca32c91c0e9717ac209845f9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedStorytellingShopAllLink_storyTellingTab$data = {
  readonly browseLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
  };
  readonly contentCreatorAttribution: {
    readonly __typename: "StoryTellingModuleCreator";
  } | null;
  readonly contentHeader: string | null;
  readonly tabType: string;
  readonly " $fragmentType": "PdpSharedStorytellingShopAllLink_storyTellingTab";
};
export type PdpSharedStorytellingShopAllLink_storyTellingTab$key = {
  readonly " $data"?: PdpSharedStorytellingShopAllLink_storyTellingTab$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedStorytellingShopAllLink_storyTellingTab">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedStorytellingShopAllLink_storyTellingTab",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "browseLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tabType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "contentHeader",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoryTellingModuleCreator",
      "kind": "LinkedField",
      "name": "contentCreatorAttribution",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "StoryTellingTab",
  "abstractKey": null
};

(node as any).hash = "64654ae7fd4808aff58aefb40b743e06";

export default node;
